import {
    PromptLabReducer
} from './PromptLabReducer';
import {
    AiTeacherReducer
} from './AiTeacherReducer';
import {
    CodeSandboxReducer
} from './CodeSandboxReducer';

// Used a common reducer for all the reducers in the app
// This is to make the actions of different apps more maintainable, when scaling
export const RootReducer = ({
    promptLab, aiTeacher, codeSandbox
}, action) => ({
    promptLab: PromptLabReducer(promptLab, action),
    aiTeacher: AiTeacherReducer(aiTeacher, action),
    codeSandbox: CodeSandboxReducer(codeSandbox, action)
});